<template>
	<header class="header-global">
		<base-nav class="navbar-main" transparent type="" effect="light" expand>
			<router-link slot="brand" class="navbar-brand mr-lg-5" to="/">
				<img src="img/aa-brand-white.png" class="logo" />
				<span class="d-inline-block">
					<span>АА Словакия</span>
					<span>Международная группа</span>
				</span>
			</router-link>

			<div class="row" slot="content-header" slot-scope="{ closeMenu }">
				<div class="col-9 collapse-brand">
					<a href="/" class="d-inline-block">
						<img src="img/aa-brand-orange.png" />
						<b>&nbsp; АА Словакия</b>
					</a>
				</div>
				<div class="col-3 collapse-close">
					<close-button @click="closeMenu"></close-button>
				</div>
			</div>

			<ul class="navbar-nav navbar-nav-hover align-items-lg-center">
				<router-link to="/" class="nav-item nav-link">Расписание</router-link>
				<router-link :to="{ name: 'donate' }" class="nav-item nav-link">7-я традиция</router-link>
				<!-- <router-link :to="{ name: 'speakers' }" class="nav-item nav-link">Спикерские</router-link> -->
				<router-link :to="{ name: 'contact' }" class="nav-item nav-link">Контакты</router-link>
			</ul>
		</base-nav>
	</header>
</template>
<script>
import BaseNav from '@/components/BaseNav';
//import BaseDropdown from "@/components/BaseDropdown";
import CloseButton from '@/components/CloseButton';

export default {
	components: {
		BaseNav,
		CloseButton,
		//BaseDropdown,
	},
};
</script>
<style lang="scss">
.navbar-main {
	padding-top: 0.8rem !important;
}

.navbar-brand {
	&:hover,
	&:focus {
		color: white !important;
	}
	img.logo {
		height: 50px;
	}
	> span {
		line-height: 1.3em;
		vertical-align: middle;
		padding-left: 10px;
		//color: #fb6340; //tomato
		//color: lightskyblue;
		//color:  $nav-link-color;

		> span:first-child {
			font-size: larger;
			display: block;
			padding-bottom: 2px;
		}

		> span:last-child {
			display: block;
			padding-left: 1px;
			text-transform: none !important;
			//color: lavender;
			//color: #ffbb77;
			//color: ivory;
			//color: rgba(ivory, 0.66);
		}
	}
}

.navbar-nav {
	.nav-item.nav-link {
		//font-weight: bold;
		font-size: large;
	}
}

.navbar-toggler {
	padding-right: 0.25rem !important;
}
</style>

